document.addEventListener('DOMContentLoaded', function () {
    const hamburger = document.querySelector('.gursian-hamburger');
    const mobileMenu = document.querySelector('.gursian-mobile-menu');

    if (hamburger && mobileMenu) {
        hamburger.addEventListener('click', function () {
            const expanded = hamburger.getAttribute('aria-expanded') === 'true' || false;
            hamburger.setAttribute('aria-expanded', !expanded);
            hamburger.classList.toggle('active');

            mobileMenu.setAttribute('aria-hidden', expanded);
            mobileMenu.classList.toggle('active');

            document.body.classList.toggle('gursian-menu-open');
        });

        // Close menu when a link inside mobile drawer is clicked
        const mobileLinks = mobileMenu.querySelectorAll('a');
        mobileLinks.forEach(link => {
            link.addEventListener('click', function () {
                hamburger.setAttribute('aria-expanded', 'false');
                hamburger.classList.remove('active');
                mobileMenu.setAttribute('aria-hidden', 'true');
                mobileMenu.classList.remove('active');
                document.body.classList.remove('gursian-menu-open');
            });
        });

        // Close menu via close icon (Event delegation)
        document.addEventListener('click', function(e) {
            const closeBtn = e.target.closest('.gursian-mobile-close');
            if (closeBtn) {
                hamburger.setAttribute('aria-expanded', 'false');
                hamburger.classList.remove('active');
                mobileMenu.setAttribute('aria-hidden', 'true');
                mobileMenu.classList.remove('active');
                document.body.classList.remove('gursian-menu-open');
            }
        });
    }

    // Add subtle parallax-tilt mouse interaction on the central card for Desktop
    const card = document.querySelector('.gursian-card');
    if (card && window.innerWidth > 1024) {
        const wrapper = document.querySelector('.gursian-card-wrapper');
        wrapper.addEventListener('mousemove', function (e) {
            const rect = card.getBoundingClientRect();
            const x = e.clientX - rect.left - (rect.width / 2);
            const y = e.clientY - rect.top - (rect.height / 2);

            const tiltX = (y / (rect.height / 2)) * -6; // Max 6 deg
            const tiltY = (x / (rect.width / 2)) * 6; // Max 6 deg

            card.style.transform = `perspective(1000px) rotateX(${tiltX}deg) rotateY(${tiltY}deg) scale(1.03)`;

            // Shine effect tracking
            const shine = card.querySelector('.gursian-card-shine');
            if (shine) {
                const px = (e.clientX - rect.left) / rect.width * 100;
                const py = (e.clientY - rect.top) / rect.height * 100;
                shine.style.background = `radial-gradient(circle at ${px}% ${py}%, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0) 80%)`;
            }
        });

        wrapper.addEventListener('mouseleave', function () {
            card.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale(1)';
            const shine = card.querySelector('.gursian-card-shine');
            if (shine) {
                shine.style.background = 'none';
            }
        });
    }

    // Contact form AJAX submission
    const contactForm = document.getElementById('gursianContactForm');
    if (contactForm) {
        contactForm.addEventListener('submit', function (e) {
            e.preventDefault();

            const submitBtn = contactForm.querySelector('button[type="submit"]');
            const messageBox = document.getElementById('gursian-form-message');
            const originalBtnText = submitBtn.innerHTML;
            
            submitBtn.innerHTML = 'SENDING...';
            submitBtn.disabled = true;
            messageBox.style.display = 'none';
            messageBox.style.color = '';

            const formData = new FormData(contactForm);

            fetch(typeof gursian_ajaxurl !== 'undefined' ? gursian_ajaxurl : '/wp-admin/admin-ajax.php', {
                method: 'POST',
                body: formData
            })
            .then(response => response.json())
            .then(data => {
                submitBtn.innerHTML = originalBtnText;
                submitBtn.disabled = false;
                
                messageBox.style.display = 'block';
                if (data.success) {
                    messageBox.style.color = '#CDFC73'; // Success color
                    messageBox.innerHTML = data.data.message;
                    contactForm.reset();
                } else {
                    messageBox.style.color = '#ff6b6b'; // Error color
                    messageBox.innerHTML = data.data.message || 'An error occurred. Please try again.';
                }
            })
            .catch(error => {
                submitBtn.innerHTML = originalBtnText;
                submitBtn.disabled = false;
                
                messageBox.style.display = 'block';
                messageBox.style.color = '#ff6b6b';
                messageBox.innerHTML = 'A network error occurred. Please try again.';
                console.error('Error:', error);
            });
        });
    }
});